module.exports = __webpack_public_path__ + "static/dhd-favicon-72-d6e16e05c7c350cfe15b36041fa9c641.png";